import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import About1 from '../Assets/About1.png'
import About2 from '../Assets/About2.png'
import About3 from '../Assets/About3.png'
import WhatsAppButton from '../Components/WhatsAppButton'

function AboutUs() {
  return (
    <>
      <Navbar />
      <div className="about-header">
        <h1>About ADL</h1>
        <p>
          Home / <span className="active">About Us</span>
        </p>
      </div>
      <div className="about-container">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="text-content">
            <h1 style={{ fontSize: '56px', lineHeight: '78.4px', fontWeight: '600' }}>Transforming Real Estate with Integrity and Innovation.</h1>
          </div>
          <div className="text-content">
            <p style={{ fontSize: '18px', lineHeight: '27px', fontWeight: '400' }}>
              At ADL Realtors, we are on a mission to redefine the real estate industry by delivering trust, expertise, and value in every transaction.
              Founded in 2024, ADL Realtors is a RERA-registered private limited company (MahaRERA No. A041262401397), established by a team of seasoned professionals with over seven years of industry experience. Our commitment is to provide honest, expert guidance that empowers our clients to make informed and responsible real estate decisions.
            </p>
          </div>
        </section>
        <section className="hero-section">
          <img src={About1} alt="Property Discussion" />
        </section>

        {/* Conduct Section */}
        <section className="conduct-section">
          <img src={About2} alt="Real estate agent with clients" />
          <div className="text-content">
            <h2>At Conduct</h2>
            <p>
              Our approach emphasizes the company’s commitment to helping clients
              achieve their dreams while positioning the brand as a transformative
              force in the real estate industry.
            </p>
          </div>
        </section>
      </div>
      <br />
      <div className="funding-container">
        {/* Funding Story Section */}
        <section className="funding-story">
          <div className="text-section">
            <h1>Our Funding Story</h1>
          </div>
          <div className="description">
            <p>
              Realty was born out of a shared passion for helping individuals and
              families find their perfect homes. The founders had experienced firsthand
              the challenges and searching for the right property.
            </p>
          </div>
        </section>
        <br />
        <div className="cards-container">
          <div className="card">
            <h2>Our Vision</h2>
            <br />
            <p>
              Our vision at Realty is to be the premier destination for individuals
              and families seeking their perfect properties. We envision a future
              where finding a home is not just a transaction but an exciting possibility.
            </p>
          </div>
          <div className="card">
            <h2>Our Mission</h2>
            <br />
            <p>
              At Realty, our mission is to empower individuals and families on their
              journey to homeownership. We are committed to providing a seamless and
              personalized experience that exceeds expectations.
            </p>
          </div>
        </div>

        <section className="adl-about-wrapper">

          <h2 className="adl-about-title">What We Offer</h2>

          <p className="adl-about-description">
            As a full-service real estate firm, we deliver comprehensive, end-to-end solutions tailored to
            meet the diverse needs of our clients. Our expertise includes:
          </p>

          <ul className="adl-about-checklist">
            <li>Land acquisitions – Identifying and securing valuable land assets</li>
            <li>Property sales – Assisting buyers and sellers with seamless transactions</li>
            <li>Investment advisory – Providing data-driven insights for profitable decisions</li>
            <li>Strategic guidance & property evaluations – Offering in-depth market analysis</li>
          </ul>
        </section>

        <section className="trust-section">
          <div className="trust-text">
            <h1>Our Approach</h1>
            <div className="trust-item">
              <p>
                We embrace a modern, client-centric approach, combining market research with strategic execution.
                Beyond traditional transactions, we offer expert advisory, evaluation, and management solutions,
                ensuring a streamlined and efficient experience for every client.
              </p>
              <br />
              <p>
                At ADL Realtors, we don’t just facilitate real estate deals—we create opportunities and deliver
                long-term value. <strong>Your vision, our expertise.</strong>
              </p>
            </div>
            <br />
          </div>
          <img src={About3} alt="Business Trust" className="trust-image" />
        </section>
        {/* <section className="trust-section">
          <div className="trust-text">
            <h1>Trust Through Openness</h1>
            <div className="trust-item">
              <h3>Clear Communication</h3>
              <br />
              <p>
                Empower businesses by providing innovative communication, PR, and
                digital solutions that drive measurable results and foster lasting success.
              </p>
            </div>
            <br />
            <div className="trust-item">
              <h3>Accountability</h3>
              <br />
              <p>
                Empower businesses by providing innovative communication, PR, and
                digital solutions that drive measurable results and foster lasting success.
              </p>
            </div>
          </div>
          <img src={About3} alt="Business Trust" className="trust-image" />
        </section> */}
      </div>
      <WhatsAppButton />
      <Footer />
    </>
  )
}

export default AboutUs